import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Article } from '../../types/content';
interface ArticleCardProps {
  article: Article;
}
export function ArticleCard({
  article
}: ArticleCardProps) {
  const href = `/insights/${article.slug}`;
  return <article className="group flex h-full flex-col" data-id="element-287" data-mp="y5isukivyy56">
      <Link to={href} className="block overflow-hidden rounded-xl bg-limestone" tabIndex={-1} aria-hidden="true" data-id="element-288" data-mp="y4pg92x8xef4">
        <img src={article.image} alt="" loading="lazy" className="aspect-[3/2] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-289" data-mp="16z4782r52de2" />
      </Link>
      <div className="mt-5 flex flex-wrap items-center gap-x-3 gap-y-2 text-xs" data-id="element-290" data-mp="1gy35qsi6wsnc">
        <span className="font-semibold text-copper-deep" data-id="element-291" data-mp="3nmzo4f9179aa">{article.category}</span>
        <span className="text-plum/55" data-id="element-292" data-mp="3ioeooi1lstmw">{article.readingTime}</span>
        {article.isSample && <span className="rounded-full border border-plum/15 px-2 py-0.5 text-plum/60" data-id="element-293" data-mp="3iqrdnf5s449g">Sample editorial</span>}
      </div>
      <h3 className="mt-3 text-xl font-semibold leading-snug text-aubergine" data-id="element-294" data-mp="zjffnkxwh4rp">
        <Link to={href} className="transition-colors duration-150 hover:text-copper-deep" data-id="element-295" data-mp="zhclqptmmrhp">
          {article.title}
        </Link>
      </h3>
      <p className="mt-3 leading-relaxed text-plum/70" data-id="element-296" data-mp="19ajw6p384xon">{article.excerpt}</p>
      <Link to={href} className="mt-auto inline-flex items-center gap-1.5 pt-5 text-sm font-semibold text-copper-deep hover:text-plum" aria-label={`Read: ${article.title}`} data-id="element-297" data-mp="1e8v3as24wu36">
        Read article
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-298" data-mp="1nackyev6x3tz" />
      </Link>
    </article>;
}